.navbar {
  background-color: rgb(70, 50, 120);
  /* display: flex; */
  align-items: center;
  height: 48px;
  z-index: 4;
  display: grid;
  grid-template-columns: [first] 20% auto [last] 20%;
}

.title {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  font-size: 14px;
  font-weight: bolder;
  text-decoration: none;
  color: rgb(243, 239, 251);

  margin: 0 auto;
}

.langAndLogoContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.langContainer {
  display: flex;
  align-items: center;
}

.logoContainer {
  justify-self: flex-end;
  padding-right: 15px;
}

.logo {
  height: 24px;
  width: 24px;
}

.toolsContainer {
  padding-left: 15px;
  display: flex;
  align-items: center;
  width: auto;
}

.languageSelect {
  max-width: 120px;
  margin-right: 125px;
}

.languageLabel {
  color: white;
}

.menuIcon {
  color: white;
  cursor: pointer;
  margin-right: 25px;
  height: 30px;
  width: 30px;
}

.icon {
  color: white;
  margin-left: 11px;
  height: 24px;
  width: 24px;
  cursor: pointer;
}

.iconSelected {
  color: #ff7917;
  margin-left: 11px;
  height: 24px;
  width: 24px;
  cursor: pointer;
}

.debugContainer {
  display: flex;
  align-items: center;
  margin-left: 15px;
}

